import { Repository } from "../../adapters/repository";
import { present } from "../../../utils/presenter";
import { Interactor } from "./types";

function createInteractor(repository: Repository): Interactor {
  return (event) =>
    present(
      repository
        .saveVideoConferenceCall(event)
        .then((link) => ({ event, link }))
        .catch(() => Promise.reject(event)),
    );
}

export type { Interactor };

export { createInteractor };
